import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import Header from '../../components/admin/Header';
import SideBar from '../../components/admin/SideBar';
import { BiUser } from 'react-icons/bi';
import axios from "axios";
import { baseUrl } from "../../shared/baseUrl";
import Swal from 'sweetalert2';

const Profile = () => {
  const navigate = useNavigate()

  const [activeTab, setActiveTab] = useState(1)

  const [toggleNav, setToggleNav] = useState(false)

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const user = JSON.parse(localStorage.getItem("profile"))

  const [firstname, setFirstname] = useState(user?.firstname)
  const [lastname, setLastname] = useState(user?.lastname)
  const [email, setEmail] = useState(user?.email)
  const [phoneNumber, setPhoneNumber] = useState(user?.phoneNumber)

  const [currentPassword, setCurrentPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmNewPassword, setConfirmNewPassword] = useState("")

  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    document.title = "Island Luxury - Profile"
		if(!userInfo) {
			navigate("/")
		}
	}, [userInfo, navigate])

  const handleUpdateProfile = (e) => {
    e.preventDefault()
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo?.token}`
      }
    }
    const updateProfile = async () => {
      try {
        setLoading(true)
        const { data } = await axios.put(baseUrl + "/api/v1/auth/profile", {
          firstname,
          lastname,
          email,
          phoneNumber
        }, config)
        Swal.fire({
          icon: 'success',
          title: 'Updated',
          text: "Your profile have been saved!"
        })
        setLoading(false)
      }
      catch (err) {
        // console.log(err.response && err.response.data.message ? err.response.data.message : err.message)
        setLoading(false)
      }
    }
    updateProfile()
  }
  
  useEffect(() => {
		if(error) {
			Swal.fire({
        icon: 'error',
        title: 'Error',
        text:  `${error}`
      })
		}
	}, [error])

  const handleResetPassword = (e) => {
    e.preventDefault()
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo?.token}`
      }
    }
    if(newPassword === confirmNewPassword) {
      const resetPassword = async () => {
        try {
          setLoading(true)
          const { data } = await axios.put(baseUrl + "/api/v1/auth/updatepassword", {currentPassword, newPassword}, config)
          Swal.fire({
            icon: 'success',
            title: 'Updated',
            text: "Your new password have been saved"
          })
          setLoading(false)
        }
        catch (err) {
          setError(err.response && err.response.data.message ? err.response.data.message : err.message)
          setLoading(false)
        }
      }
      resetPassword()
    }
    else {
      setError("Passwords do not match!")
    }
  }

  return (
    <div id="admin-page_wrap">
      <Header toggleNav={toggleNav} setToggleNav={setToggleNav} />
      <SideBar toggleNav={toggleNav} />
      <main id="profile">
        <section className="page-title">
          <h3><NavLink to="/dashboard">Dashboard</NavLink> | My Profile</h3>
        </section>
        <section className="profile-details_cont">
          <div className="user-info">
            <BiUser size={80} />
            <div className="user-detail">
              <h3>{user?.firstname} {user?.lastname}</h3>
              <p>@{user?.username}</p>
              {user?.role === "estate-agent" ? 
                <p>Estate Agent</p>
              :
                <p>Administrator</p>
              }
            </div>
          </div>
          <ul className="nav-tabs">
            <li className={activeTab === 1 ? "active" : ""} onClick={() => setActiveTab(1)}>Edit Profile</li>
            <li className={activeTab === 2 ? "active" : ""} onClick={() => setActiveTab(2)}>Reset Password</li>
          </ul>
          {activeTab === 1 && (
            <form className="edit-profile" onSubmit={handleUpdateProfile}>
              <div className="form-grp">
                <label htmlFor="fname">First Name</label>
                <input type="text" id="fname" value={firstname} onChange={(e) => setFirstname(e.target.value)} required />
              </div>
              <div className="form-grp">
                <label htmlFor="lname">Last Name</label>
                <input type="text" id="lname" value={lastname} onChange={(e) => setLastname(e.target.value)} required />
              </div>
              <div className="form-grp">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <div className="form-grp">
                <label htmlFor="phone">Phone No: (Whatsapp)</label>
                <input type="tel" id="phone" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} required />
              </div>
              <div className="form-grp">
                <label htmlFor="alt-phone">Alt. Phone No:</label>
                <input type="tel" id="alt-phone" />
              </div>
              <div className="form-grp">
                <label htmlFor="address">Address</label>
                <input type="text" id="address" />
              </div>
              <div className="form-grp">
                <label htmlFor="comp-name">Company Name</label>
                <input type="text" id="comp-name" />
              </div>
              <div className="form-grp">
                <label htmlFor="web">Website</label>
                <input type="text" id="web" />
              </div>
              <div className="form-grp span">
                <label htmlFor="about">About</label>
                <textarea id="about" rows="5"></textarea>
              </div>
              <div className="form-grp_btn">
                <button type="submit" disabled={loading && true}>
                  {loading ? "Saving..." : "Save Changes"}
                </button>
              </div>
            </form>
          )}
          {activeTab === 2 && (
            <form className="edit-profile" onSubmit={handleResetPassword}>
              <div className="form-grp">
                <label htmlFor="currentcode">Current Password</label>
                <input type="password" id="currentcode" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required />
              </div>
              <div className="form-grp">
                <label htmlFor="newcode">New Password</label>
                <input type="password" id="newcode" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
              </div>
              <div className="form-grp">
                <label htmlFor="confirmcode">Confirm New Password</label>
                <input type="password" id="confirmcode" value={confirmNewPassword} onChange={(e) => setConfirmNewPassword(e.target.value)} required />
              </div>
              <div className="form-grp_btn">
                <button type="submit" disabled={loading && true}>
                  {loading ? "Resetting..." : "Reset Password"}
                </button>
              </div>
            </form>
          )}
        </section>
      </main>
    </div>
  )
}

export default Profile;